<template>
  <div class="fixed-bottom-left">
    <slot />
  </div>
</template>

<script>
/**
 * @description 画面左下に固定したい場合のコンポーネント
 * 子を複数置くと下から順に積み上がる
 */
export default {
}
</script>

<style lang="scss" scoped>
.fixed-bottom-left {
  z-index: 100;
  position: fixed;
  bottom: calc(env(safe-area-inset-bottom) + 96px);
  left: calc(env(safe-area-inset-left) + 16px);
  display: flex;
  // DOM の先頭が一番下に来る
  flex-direction: column-reverse;
  gap: 20px;

  @media (min-width: 992px) {
    // 120px: ナビゲーションサイドバー(NavigationMenuForPC)
    // 302px: コンテンツサイドバー(MemberSelectMenu / CategorySelectMenu)
    // 61px: 余白
    left: 483px;
  }
}
</style>
